import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { bool, shape, string } from "prop-types";
import { Field, Form, Formik } from "formik";
import { Col, Row } from "react-bootstrap";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import * as numberUtils from "util/number";
import { selectors as loansSelectors, actions as loansActions } from "reducers/loans";
import { selectors as softTokenSelectors } from "reducers/softToken";
import Credential from "pages/_components/fields/credentials/Credential";
import Check from "pages/_components/fields/Checkbox";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import { isIOS } from "react-device-detect";
import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import GridTable from "../../_components/GridTable/GridTable";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";

const UnsecuredLoanFormConfirm = ({
    isDesktop,
    amount,
    destinyFund,
    documentLastBalance,
    documentSalesAfterBalance,
    documentCashflow,
    fetching,
}) => {
    const dispatch = useDispatch();
    const [checkboxState, setCheckboxState] = useState(false);
    const [checkboxError, setCheckboxError] = useState(false);

    const handleCheckboxChange = () => {
        setCheckboxError(false);
        setCheckboxState(!checkboxState);
    };

    useEffect(() => {
        dispatch(loansActions.unsecuredLoanAplicationSetButtonLoading(false));
    }, []);

    const requestBody = {
        amount: {
            quantity: amount,
            currency: "ARS",
        },
        loanPurpose: destinyFund?.label,
        documentLastBalance,
        documentSalesAfterBalance,
        documentCashflow,
    };

    const infoFirstRow = () => (
        <GridTable>
            <GridTable.Container columns={12} columnsTemplate="fixed">
                <GridTable.Data columnStart={2} rowStart={1} columnWidth={12}>
                    <div
                        style={{
                            paddingBottom: "15px",
                            fontFamily: "var(--h3-desktop-font-family)",
                            fontSize: "var(--h3-desktop-font-size)",
                        }}>
                        {i18n.get("loans.customLoan.confirm.detailCard.title")}
                    </div>
                </GridTable.Data>
                <GridTable.Data columnStart={2} rowStart={3} columnWidth={isDesktop ? 2 : 6}>
                    <CustomData
                        titleText={i18n.get("loans.customLoan.confirm.detailCard.amount.label")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={
                            <FormattedAmount currency="ARS" quantity={numberUtils.formatAmountStrDouble(amount)} />
                        }
                    />
                </GridTable.Data>
                <GridTable.Data
                    columnStart={isDesktop ? 6 : 7}
                    rowStart={isDesktop ? 3 : 3}
                    columnWidth={isDesktop ? 2 : 6}>
                    <CustomData
                        titleText={i18n.get("loans.customLoan.confirm.detailCard.fundDestiny.label")}
                        titleTextType="TEXT"
                        valueTextType="TEXT"
                        valueText={destinyFund?.label}
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );

    return (
        <>
            <Notification scopeToShow="loans" />{" "}
            <CustomProductHead titleId="loans.customLoan.confirm.header.title" backLinkTo="/requestCustomLoan">
                <div className="toolbar-item view-title">
                    <ViewTitle id="loans.customLoan.confirm.header.title" />
                </div>
            </CustomProductHead>
            <MainContainer showLoader={fetching}>
                <Row className="form-background">
                    <div>{infoFirstRow()}</div>
                </Row>
                <div style={{ paddingBottom: "10px" }} />

                <EmptyScreenAlert message="loans.customLoan.confirm.requestInformation.text" />

                <Row>
                    <Col xs={12} md={1} lg={12} className="mt-8 ml-8">
                        <div className="d-flex align-items-center">
                            <div style={isIOS ? { width: "var(--space-9)" } : null}>
                                <Check
                                    hideLabel
                                    name="termsAndConditios"
                                    onChange={handleCheckboxChange}
                                    checked={checkboxState}
                                    error={checkboxError ? "Campo requerido" : ""}
                                />
                            </div>
                            <div className="d-flex pb-4">
                                <div className={isIOS ? "whitespace-nowrap pr-3" : "pr-3"}>
                                    {i18n.get("loans.customLoan.confirm.acceptTerms.text")}
                                </div>
                                <div
                                    aria-hidden="true"
                                    className={isIOS ? "whitespace-nowrap btn-link" : "btn-link"}
                                    onClick={() => {
                                        dispatch(loansActions.downloadUnsecuredLoansApplicationTerms());
                                    }}>
                                    {i18n.get("global.termAndConditions")}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <GeneralCredentialForm
                        transactionData={requestBody}
                        type="otp"
                        action={loansActions.requestCustomLoan}
                        idActivity="request.custom.loan"
                        hideIndications
                        isDisabled={!checkboxState}
                    />
                </Row>
            </MainContainer>
        </>
    );
};

UnsecuredLoanFormConfirm.propTypes = {
    isDesktop: bool.isRequired,
    deviceStatus: string.isRequired,
    tokenInfo: shape({}).isRequired,
    fetching: bool.isRequired,
};

const mapStateToProps = (state) => ({
    tokenInfo: softTokenSelectors.getTokenInfo(state),
    deviceStatus: softTokenSelectors.getDeviceStatus(state),
    destinyFund: state.loans.destinyFundList.find((destiny) => destiny.value == state.loans.destinyFund),
    amount: state.loans.amount,
    documentLastBalance: state.loans.documentLastBalance,
    documentSalesAfterBalance: state.loans.documentSalesAfterBalance,
    documentCashflow: state.loans.documentCashflow,
    fetching: loansSelectors.getFetching(state),
});

export default connect(mapStateToProps)(UnsecuredLoanFormConfirm);
